<template>
    <div id="detail_info">
        <div id="detail_info_content">
            <div id="info_content_txt">
                <div id="campaign_name">
                    {{campaign.name}}
                </div>
                <div id="campaign_point" v-if="isShowPoint">
                    <div class="wrapper-point">
                        <div id="point_box">
                            <div class="point-val">
                                {{ isShowBaht ?  (campaign.maximumPartialPoints | number_format)  : showPoint }}
                            </div>
                            <div class="point-ic"></div>
                        </div>
                        <div class="campaign-baht" v-if="isShowBaht">
                            + {{ campaign.maximumPartialPrice | number_format }} {{ lbl.campaign.unit_price }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import LocaleMixin from "@/mixin/LocaleMixin";
import Util from '@/helper/Utility.js';

export default {
    name: 'DetailInfo',
    mixins: [LocaleMixin],
    props: {
        campaign: Object
    },
    data: function() {
        return {
            isShowPoint: true,
        }
    },
    computed: {
        isShowBaht: function () {
            return (this.campaign.type == Vue.CampaignType.Privilege);
        },
        showPoint: function () {
            let point = Util.formatNum(this.campaign.pointPerUnit, 0);
            if(point == 0){
                point = this.lbl.campaign.free;
            }
            return point;
        },
    },
    created: function(){
        console.log('campaign', this.campaign);

        if(this.campaign.type == Vue.CampaignType.Event){
            this.isShowPoint = false;
        }
        if(this.campaign.interfaceDisplay =="survey" && this.campaign.categoryName == "Survey Draw" && this.campaign.pointPerUnit == 0){
            this.isShowPoint = false;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseText.scss";
#detail_info {
    padding: {
        top: 15px;
        left: 18px;
        right: 18px;
    };

    #detail_info_content {
        @extend %display-flex;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        overflow: hidden;
        //font
        font-size: 1rem;

        #info_content_txt {
            width: 100%;
            flex: 0 0 100%;
            margin: auto 0;

            #campaign_name {
                color: $white;
                font-family: $medium;
                font-size: 1.25rem;
                word-break: break-word;
            }
        }
    }

}

#point_box {
    @include point-box('../../../../assets/icon/ic-point.svg');
}

.wrapper-point{
    display: flex;
    align-items: center;
    gap: 10px;
    margin: {
        top: 10px;
    };

    .campaign-baht{
        font-family: $medium;
        font-size: 1.3rem;
        color: $white;
    }
}
</style>
